import axios from "axios";


export const submitAndRecieveFee = (patientId, data) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/${patientId}/OPD`, data);
  };